'use strict';

/**
 * sex
 * 上下午标识
 * @param str
 * @param mode
 * 0 [1-上午,2-下午，3-全天]
 * @returns {*}
 */
module.exports = function (str) {
    var mode = arguments.length > 1 && arguments[1] !== undefined ? arguments[1] : 0;

    if (str === undefined) return "";

    switch (mode) {
        case 0:
            return {
                0: '',
                1: '上午',
                2: '下午',
                3: '全天',
                15: '上午',
                16: '下午'
            }[str];
            break;

        case 1:
            break;

        case 2:
            if (!str) {
                return "";
            }
            str = str.toLowerCase();
            return { m: '男', f: '女' }[str];
            break;
    }
};